import { render } from "./CurrentMessageView.vue?vue&type=template&id=0e5e112b&scoped=true"
import script from "./CurrentMessageView.vue?vue&type=script&lang=js"
export * from "./CurrentMessageView.vue?vue&type=script&lang=js"

import "./CurrentMessageView.vue?vue&type=style&index=0&id=0e5e112b&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e5e112b"]])

export default __exports__